import request from '@/utils/request';

export function getCertificateList(params, silentRequest = false) {
  return request({
    url: '/Certificate/explore',
    params,
    silentRequest,
  });
}

export function getCertificateDetail(id) {
  return request({
    url: '/Certificate/detail',
    params: { id },
  });
}

export function showCertificatePopup(targetType, targetId, silentRequest = true) {
  return request({
    url: '/Certificate/showPopup',
    params: {
      targetType,
      targetId,
    },
    silentRequest,
  });
}
